<div class="flex items-center gap-2 custom-form">
  <!-- Start Date Picker -->
  <div class="flex flex-col w-full min-w-[180px] cursor-pointer" (click)="openStartPicker($event)">
    @let isStartInvalid = startDateControl().invalid && startDateControl().touched && !anyPickersOpen();

    <mat-form-field
      class="flex-1 [&_input]:pointer-events-none mat-mdc-form-field-type-mat-date-picker"
      [class.active-datepicker]="startRangePicker?.opened"
      [class.mat-form-field-invalid]="isStartInvalid"
    >
      <mat-label>
        {{ startDateLabel() || ('pages.campaignForm.sections.basics.startDatePlaceholder' | translate) }}
      </mat-label>
      <input
        readonly
        matInput
        [disabled]="startDateControl().disabled"
        [value]="startDateControl().value | date: 'dd.MM.yyyy HH:mm'"
        (keydown.enter)="openStartPicker($event)"
        (keydown.alt.arrowdown)="openStartPicker($event)"
      />

      <div matSuffix class="flex items-center gap-1">
        <app-icon src="icons/chevron-down.svg" [size]="20" />
      </div>
      <mat-date-range-picker #startRangePicker></mat-date-range-picker>
      <mat-error [control]="startDateControl()" />

      <!-- Picker anchors only: readonly and out of the tab order, so nothing can be typed into them unseen. -->
      <div class="opacity-0">
        <mat-date-range-input
          #startRangeInput="matDateRangeInput"
          [rangePicker]="startRangePicker"
          [min]="minDate()"
          [max]="maxDate()"
        >
          <input matStartDate readonly tabindex="-1" [formControl]="startDateControl()" />
          <input matEndDate readonly tabindex="-1" [formControl]="endDateControl()" />
        </mat-date-range-input>
      </div>
    </mat-form-field>

    @if (isStartInvalid) {
      <mat-error class="text-[10px] pl-[22px] pr-4" [control]="startDateControl()" />
    }
  </div>

  <!-- End Date Picker -->
  <div class="flex flex-col w-full min-w-[180px] cursor-pointer" (click)="openEndPicker($event)">
    @let isEndInvalid = endDateControl().invalid && endDateControl().touched && !anyPickersOpen();

    <mat-form-field
      class="flex-1 [&_input]:pointer-events-none mat-mdc-form-field-type-mat-date-picker"
      [class.active-datepicker]="endDatePicker?.opened"
      [class.mat-form-field-invalid]="isEndInvalid"
    >
      <mat-label>
        {{ endDateLabel() || ('pages.campaignForm.sections.basics.endDatePlaceholder' | translate) }}
      </mat-label>
      <input
        readonly
        matInput
        class="max-h-[48px]"
        [disabled]="endDateControl().disabled"
        [value]="endDateControl().value | date: 'dd.MM.yyyy HH:mm'"
        (keydown.enter)="openEndPicker($event)"
        (keydown.alt.arrowdown)="openEndPicker($event)"
      />

      <div matSuffix class="flex items-center gap-1">
        <app-icon src="icons/chevron-down.svg" [size]="20" />
      </div>
      <mat-datepicker
        #endDatePicker
        [panelClass]="datePickerUtilities.endPickerPanelClass"
        [dateClass]="datePickerUtilities.endPickerDateClass(startDateControl().value, endDateControl().value)"
      ></mat-datepicker>
      <mat-error [control]="endDateControl()" />

      <div class="opacity-0">
        <input
          readonly
          tabindex="-1"
          matInput
          [matDatepicker]="endDatePicker"
          [disabled]="endDateControl().disabled"
          [min]="getEndMinDate()"
          [max]="maxDate()"
          [value]="endDateControl().value"
          (dateInput)="onEndDateChange($event.value ?? null)"
        />
      </div>
    </mat-form-field>

    @if (isEndInvalid) {
      <mat-error class="text-[10px] pl-[22px] pr-4" [control]="endDateControl()" />
    }
  </div>
</div>
